import { Component, OnInit } from '@angular/core';
import { CatalogueService } from 'app/components/catalogue/catalogue.service';
import { Router, ActivatedRoute } from '@angular/router';
import { SessionService } from 'app/components/common/session/session.service';
import { TranslateService } from '@ngx-translate/core';
import { Title } from '@angular/platform-browser';
import { LoginService } from 'app/components/login/login.service';
import { CONSTANTS } from 'environments/common';
import { CatalogueUserService } from 'app/components/catalogueUser/catalogue-user.service';
import { AnalyticsService } from 'app/components/analytics/analytics.service';
import { NgbModal, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';
import { ModalRedirectSdaComponent } from 'app/components/modal-redirect-sda/modal-redirect-sda.component';

@Component({
  selector: 'app-auto-login',
  templateUrl: './auto-login.component.html',
  styleUrls: ['./auto-login.component.scss']
})
export class AutoLoginComponent implements OnInit {

  loader: any = {
    count: 0
  };
  alertType: string = '';
  alertMessage: string = '';
  cards: Array<any> = [];

  currentYear: number;

  availableLanguages: string[] = ['ca', 'es', 'en'];
  currentLanguage: string = 'es';

  userName: string = '';
  token: string = '';
  eventName: string = '';
  eventData: object = {};

  constructor(private router: Router, private sessionService: SessionService, private translate: TranslateService, private loginService: LoginService, private activatedRoute: ActivatedRoute, private catalogueService: CatalogueService,
    private catalogueUserService: CatalogueUserService, private analyticsService: AnalyticsService, private modalService: NgbModal) {
    this.eventName = this.activatedRoute.snapshot.paramMap.get('event') || '';
    this.userName = this.activatedRoute.snapshot.paramMap.get('userName') || '';
    this.token = this.activatedRoute.snapshot.paramMap.get('token') || '';
  }

  getUser(getUserIn) {

    this.loader.count++;
    this.alertType = '';
    this.alertMessage = '';

    this.loginService.getUser(getUserIn)
      .subscribe((data: object) => {
        this.getUserOk(data);
      },
        error => {
          this.getUserError(error);
        });

  }

  getUserOk(data) {

    this.loader.count--;
    /** Update username in sesion */
    let nameStorageUsername = `username_${this.eventData['sapCode']}`;
    this.sessionService.set(nameStorageUsername, data['username'], true);

    if (this.checkUserProfile(data)) {

      this.setUserProfile(data);

      let checkLoggedUserIn = {
        eventName: this.eventData['eventName']
      };

      this.checkLoggedUser(checkLoggedUserIn);

    } else {

      let checkAttendeeIn = {
        eventsCode: [this.eventData['sapCode']]
      };

      this.checkAttendee(checkAttendeeIn);

    }

  }

  getUserError(error) {

    let alertData = {
      alertType: 'error',
      alertMessage: error.message
    }

    this.loader.count--;
    this.alertType = alertData.alertType;
    this.alertMessage = alertData.alertMessage;

  }

  setToken(token) {
    let nameStorageToken = `token_${this.eventData['sapCode']}`;
    this.sessionService.set(nameStorageToken, token, true);
    let nameStorageUsername = `username_${this.eventData['sapCode']}`;
    this.sessionService.set(nameStorageUsername, this.userName, true);
  }

  findByEventName(findByEventNameIn) {

    this.loader.count++;
    this.alertType = '';
    this.alertMessage = '';

    this.catalogueService.findByEventName(findByEventNameIn)
      .subscribe((data: object) => {
        this.findByEventNameOk(data);
      },
        error => {
          this.findByEventNameError(error);
        });

  }

  findByEventNameOk(data) {

    this.loader.count--;
    this.sessionService.set('eventData', data, false);
    this.sessionService.set('catalogId', data['id'], false);
    this.eventData = data;
    this.catalogueService.setData(data);

    if (this.userName && this.token) {
      this.setToken(this.token);
      this.getUser(this.token);
    }

  }

  findByEventNameError(error) {

    let alertData = {
      alertType: 'error',
      alertMessage: error.message
    }

    this.loader.count--;
    this.alertType = alertData.alertType;
    this.alertMessage = alertData.alertMessage;

  }

  checkUserProfile(profile) {

    let validUser = false;

    for (let i = 0; i < profile.authorities.length; i++) {
      if (CONSTANTS.VALID_ROLES.indexOf(profile.authorities[i].name) !== -1) {
        validUser = true;
      }
    }

    return validUser;

  }

  setUserProfile(profile) {
    let nameStorageProfile = `profile_${this.eventData['sapCode']}`;
    this.sessionService.set(nameStorageProfile, profile, true);
  }

  checkLoggedUser(checkLoggedUserIn) {

    this.loader.count++;
    this.alertType = '';
    this.alertMessage = '';

    this.loginService.checkLoggedUser(checkLoggedUserIn)
      .subscribe((data: object) => {
        this.checkLoggedUserOk(data);
      },
        error => {
          this.checkLoggedUserError(error);
        });

  }

  checkLoggedUserOk(data) {
    this.loader.count--;
    let nameStorage = `catalogueUser_${this.eventData['sapCode']}`;
    this.sessionService.set(nameStorage, data, true);
    this.analyticsService.sendLogin('OK', '');
    this.goToHome();
  }

  checkLoggedUserError(error) {

    let alertData = {
      alertType: 'error',
      alertMessage: error.message
    }

    this.loader.count--;
    this.alertType = alertData.alertType;
    this.alertMessage = alertData.alertMessage;
    this.analyticsService.sendLogin('KO', alertData.alertMessage);

  }

  checkAttendee(checkAttendeeIn) {

    this.loader.count++;
    this.alertType = '';
    this.alertMessage = '';

    this.loginService.checkAttendee(checkAttendeeIn)
      .subscribe((data: object) => {
        this.checkAttendeeOk(data);
      },
        error => {
          this.checkAttendeeError(error);
        });

  }

  checkAttendeeOk(data) {

    this.loader.count--;
    if (!data.ticketMinimalDTOS) {
      const modalRef = this.modalService.open(ModalRedirectSdaComponent);
      this.loginService.removeSessionVariables();
      this.analyticsService.sendLogin('KO', 'Attendee has no ticket.');
    } else {
      this.analyticsService.sendLogin('OK', '');
      this.goToHome();
    }
  }

  checkAttendeeError(error) {

    let alertData = {
      alertType: 'error',
      alertMessage: error.message
    }

    this.loader.count--;
    this.alertType = alertData.alertType;
    this.alertMessage = alertData.alertMessage;
    this.analyticsService.sendLogin('KO', alertData.alertMessage);

  }

  goToHome() {
    this.router.navigate([ this.eventName + '/exhibitor-backoffice/exhibitors/']);
  }

  ngOnInit() {

    this.sessionService.set('eventName', this.eventName, false);

    let findByEventNameIn = {
      eventCode: this.eventName
    };

    this.findByEventName(findByEventNameIn);


  }


}
